export enum AppElementsProviderEventTypes {
    ContainerRemoved = "container-removed",
    StyledContainerRegistered = "styled-container-registered",
    StyledContainerUnregistered = "styled-container-unregistered",
}
